const home = [
  {
    path: '/home/conta',
    name: 'conta',
    component: () => import('@/pages/conta/ContaView.vue'),
    meta: {
      layout: 'content',
      id: 1022,
    },
  },
  {
    path: '/home/cargos',
    name: 'cargos',
    component: () => import('@/pages/cargo/CargoList.vue'),
    meta: {
      layout: 'content',
      id: 1024,
    },
  },
  {
    path: '/home/cargo/:id',
    name: 'cargo',
    component: () => import('@/pages/cargo/CargoView.vue'),
    meta: {
      layout: 'content',
      id: 1025,
    },
  },
  {
    path: '/home/colaboradores',
    name: 'colaboradores',
    component: () => import('@/pages/colaborador/ColaboradorList.vue'),
    meta: {
      layout: 'content',
      id: 1021,
    },
  },
  {
    path: '/home/colaborador/:id',
    name: 'colaborador',
    component: () => import('@/pages/colaborador/ColaboradorView.vue'),
    meta: {
      layout: 'content',
      id: 1022,
    },
  },
  {
    path: '/home/departamentos',
    name: 'departamentos',
    component: () => import('@/pages/departamento/DepartamentoList.vue'),
    meta: {
      layout: 'content',
      id: 1028,
    },
  },
  {
    path: '/home/departamento/:id',
    name: 'departamento',
    component: () => import('@/pages/departamento/DepartamentoView.vue'),
    meta: {
      layout: 'content',
      id: 1029,
    },
  },
  {
    path: '/home/perfis',
    name: 'perfis',
    component: () => import('@/pages/perfil/PerfilList.vue'),
    meta: {
      layout: 'content',
      id: 1026,
    },
  },
  {
    path: '/home/perfil/:id',
    name: 'perfil',
    component: () => import('@/pages/perfil/PerfilView.vue'),
    meta: {
      layout: 'content',
      id: 1027,
    },
  },
  {
    path: '/manutencao',
    name: 'manutencao',
    component: () => import('@/pages/acesso/TelaEmManutencao.vue'),
    meta: {
      layout: 'content',
      id: 1,
    },
  },
  {
    path: '/nao-autorizado',
    name: 'nao-autorizado',
    component: () => import('@/pages/acesso/AcessoNegado.vue'),
    meta: {
      layout: 'content',
      id: 2,
    },
  },
  {
    path: '/home/empresa',
    name: 'empresa',
    component: () => import('@/pages/empresa/EmpresaView.vue'),
    meta: {
      layout: 'content',
      id: 1030,
    },
  },
  {
    path: '/completar-cadastro',
    name: 'completar-cadastro',
    component: () => import('@/pages/empresa/StepperEmpresaSettings.vue'),
    meta: {
      layout: 'blank',
      id: 3,
    },
  },
]

export default home
